import axios from 'axios'
import { isTokenExpired } from '../utils/Token'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL_BASE,
  withCredentials: true
})

function refreshToken (refreshToken) {
  const resp = axios.post(`${process.env.VUE_APP_API_URL_BASE}/api/v1/auth/gera-novo-token`, {
    token: refreshToken
  })
  resp.then(resposta => {
    localStorage.setItem('Token_CAPAF', resposta.data.token)
    localStorage.setItem('Refresh_Token_CAPAF', resposta.data.refreshToken)
  })
  return resp
}

http.interceptors.request.use(async function (request) {
  const token = localStorage.getItem('Token_CAPAF')
  if (token === null || (token !== null && isTokenExpired(token))) {
    const refreshTokenAtual = localStorage.getItem('Refresh_Token_CAPAF')
    if (refreshTokenAtual !== null && !isTokenExpired(refreshTokenAtual)) {
      const resp = await refreshToken(refreshTokenAtual)
      request.headers.Authorization = `Bearer ${resp.data.token}`
    } else {
      localStorage.removeItem('Token_CAPAF')
      localStorage.removeItem('Refresh_Token_CAPAF')
    }
  } else if (token) {
    request.headers.Authorization = `Bearer ${token}`
  }
  return request
})

export default http
